import type { HelpFile } from '../../types/help'
import { NotificationTemplateDetailTestIds } from '../../../testids/NotificationTemplateDetailTestIds'

export const notificationTemplateDetailHelp: HelpFile = {
  docPage: '/docs/admin/notification-templates',
  texts: {
    [NotificationTemplateDetailTestIds.notificationTemplateDetailPage]:
      'Edit the subject, body, title, and message of this notification template. Saving creates a database override; "Restore Default" reverts to the shipped classpath template.',
    [NotificationTemplateDetailTestIds.cardNotificationTemplateMetadata]: null,
    [NotificationTemplateDetailTestIds.cardTitleEditor]:
      'Edit the subject, body, title, and message. Use the variable picker to insert Thymeleaf tokens into the body.',
    [NotificationTemplateDetailTestIds.badgeCustomised]:
      'Indicates whether a database override backs this template ("Customised") or the shipped default is in use ("Default").',
    [NotificationTemplateDetailTestIds.badgeDefault]: null,
    [NotificationTemplateDetailTestIds.inputSubject]:
      'The email subject line. Thymeleaf variable tokens such as [[${requesterName}]] are substituted at send time.',
    [NotificationTemplateDetailTestIds.textareaBody]:
      'The HTML email body. Insert variable tokens from the picker on the right at the cursor position.',
    [NotificationTemplateDetailTestIds.inputTitle]:
      'Optional in-app notification title.',
    [NotificationTemplateDetailTestIds.textareaMessage]:
      'Optional in-app notification message.',
    [NotificationTemplateDetailTestIds.variablePicker]:
      'Variables declared for this event type. Click one to insert its Thymeleaf token at the cursor position in the body.',
    [NotificationTemplateDetailTestIds.btnSave]: null,
    [NotificationTemplateDetailTestIds.btnCancel]: null,
    [NotificationTemplateDetailTestIds.btnRestoreDefault]:
      'Delete the database override so the template reverts to the shipped classpath default.',
    [NotificationTemplateDetailTestIds.btnTestSend]:
      'Render the template with sample variables and send one test mail to your own email address.',
    [NotificationTemplateDetailTestIds.dialogRestoreDefault]: null,
  },
}
